RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const states = data.DataUpdateStates = {
        UNINITIALIZED: 0,
        NO_UPDATE: 1,
        UPDATE_IN_FLIGHT: 2,
        UPDATE_COMPLETE: 3,
        ERROR: 4
    };

    data.DataUpdatePoller = Backbone.Model.extend({
        url: function () {
            const me = this;
            return `/api/landscape/${me.get('landscapeId')}/isDataUpdateInFlight`;
        },
        eventName: 'landscapeDataUpdateStatus',
        state: states.UNINITIALIZED,
        postTagUpdateState: states.UNINITIALIZED,

        changeState: function (newState) {
            const me = this;

            me.state = newState;
            RivalIQ.state.landscape.set(me.eventName, newState);
        },

        changePostTagUpdateState: function (newState, autoTagRulesInFlight) {
            const me = this;

            me.postTagUpdateState = newState;
            RivalIQ.state.landscape.set('postTagUpdateStatus', newState);

            const inflightAutoTagRulesById = _.keyBy(autoTagRulesInFlight, 'id');

            const existingRulesInflight = RivalIQ.state.landscape.get('postTagsAutoTagRulesInFlight');
            autoTagRulesInFlight = _.reduce(autoTagRulesInFlight, function (memo, newRule) {
                if (!_.find(memo, {
                    id: newRule.id
                })) {
                    memo.push(newRule);
                }
                return memo;
            }, existingRulesInflight || []);

            _.each(autoTagRulesInFlight, autoTagRule => {
                autoTagRule.complete = !inflightAutoTagRulesById[autoTagRule.id];
            });

            RivalIQ.state.landscape.set('postTagsAutoTagRulesInFlight', autoTagRulesInFlight);
        },

        // exposed for testing
        condition: function (data) {

            const me = this;

            if (me.isDisabled) {
                return true;
            }

            if (me.state === states.UNINITIALIZED) {

                if (!data.updateInFlight) {
                    if (data.data_version === RivalIQ.state.landscape.get('data_version')) {
                        me.changeState(states.NO_UPDATE);
                    } else {
                        me.changeState(states.UPDATE_COMPLETE);
                    }
                } else {
                    me.changeState(states.UPDATE_IN_FLIGHT);
                }

            } else if (me.state === states.UPDATE_IN_FLIGHT && !data.updateInFlight) {
                // NOTE: we force data freshness spinner to spin when a new company is added
                // setting companyAdded to false will end the force spin
                RivalIQ.state.landscape.set('companyAdded', false);
                me.changeState(states.UPDATE_COMPLETE);
            }

            if (me.postTagUpdateState === states.UNINITIALIZED) {

                if (_.isEmpty(data.autoTagRulesInFlight)) {
                    me.changePostTagUpdateState(states.NO_UPDATE);
                } else {
                    me.changePostTagUpdateState(states.UPDATE_IN_FLIGHT, data.autoTagRulesInFlight);
                }

            } else {
                if (!_.isEmpty(data.autoTagRulesInFlight)) {
                    me.changePostTagUpdateState(states.UPDATE_IN_FLIGHT, data.autoTagRulesInFlight);
                } else {
                    if (me.postTagUpdateState !== states.NO_UPDATE) {
                        me.changePostTagUpdateState(states.UPDATE_COMPLETE);
                    } else {
                        me.changePostTagUpdateState(states.NO_UPDATE);
                    }
                }
            }

            return !data.updateInFlight && !data.autoTagRulesInFlight;
        },

        poll: function () {

            const me = this;

            const api = function () {

                if (me.isDisabled) {
                    return $.when(false);
                }

                return $.get(me.url());
            };

            const onFailure = function (error) {

                me.changeState(states.ERROR);
            };

            const options = {
                skipFailFast: true,
                pollingDelay: 15000
            };

            const deferred = RivalIQ.utils.polling.pollUntilCondition(api, _.bind(me.condition, me), options);
            deferred.fail(onFailure);

            return deferred;
        },

        disable: function () {
            const me = this;
            me.isDisabled = true;
        }
    });

});
